import { ENV } from "./env.util";

const IMAGE_DOMAIN = ENV.VITE_IMAGE_API_ENDPOINT || "https://d363r49np5tk98.cloudfront.net";
const BUCKET = ENV.VITE_AWS_IMAGES_BUCKET || "hautesociete-user-photos-v2";

/**
 * @description Serverless Image Handler
 * @url https://d2qnb1baxbnyux.cloudfront.net/index.html
 */
export const ImgSrc = (awsPath: string, size?: number, smartCrop?: boolean) => {
  // Dev: MinIO serves images directly via plain path URLs
  if (ENV.VITE_APP_ENV === "local") {
    return `${IMAGE_DOMAIN}/${BUCKET}/${awsPath}`;
  }

  // Prod: Serverless Image Handler uses base64-encoded request
  const request = {
    bucket: BUCKET,
    key: awsPath,
    edits: {},
  };

  if (size) {
    request.edits = {
      ...request.edits,
      resize: {
        width: size,
        height: size,
        fit: "cover",
      },
    };
  }
  if (smartCrop) {
    request.edits = {
      ...request.edits,
      smartCrop: {
        padding: 130,
      },
    };
  }

  const strRequest = JSON.stringify(request);

  try {
    const encRequest = btoa(strRequest);

    return `${IMAGE_DOMAIN}/${encRequest}`;
  } catch (error) {
    console.log(error);
  }
};
